import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function FadeIn({ children, delay = 0, y = 28, className = "", ...rest }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({
  lines,
  className = "",
  lineClassName = "",
  delay = 0,
  as: Tag = "h1",
  onView = false,
}) {
  return (
    <Tag className={className}>
      {lines.map((line, i) => {
        const motionProps = onView
          ? {
              initial: { y: "110%" },
              whileInView: { y: 0 },
              viewport: { once: true, margin: "-60px" },
            }
          : { initial: { y: "110%" }, animate: { y: 0 } };
        return (
          <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
            <motion.span
              {...motionProps}
              transition={{ duration: 0.9, delay: delay + i * 0.12, ease: EASE }}
              className={`block will-change-transform ${lineClassName}`}
            >
              {line}
            </motion.span>
          </span>
        );
      })}
    </Tag>
  );
}

export function Chapter({ index, label, className = "" }) {
  return (
    <FadeIn y={12} className={`flex items-center gap-4 ${className}`}>
      <span className="font-serif text-base italic text-sage-dark">{index}</span>
      <span className="h-px w-10 bg-sage" />
      <span className="text-xs font-bold uppercase tracking-[0.25em] text-brand">
        {label}
      </span>
    </FadeIn>
  );
}
